import { lazyLoad, createIcon } from "./helpers";
import { projectRoutes, instituteRoutes, trainingRoutes, userRoutes,
    toolsRoutes, scheduleRoutes, reportRoutes, inventoryRoutes } from "./subRoutes";

const Dashboard = lazyLoad("Dashboard");
const Profile = lazyLoad("Profile");
const Administrator = lazyLoad("Administrator");
const TypeOfAdmin = lazyLoad("Administrator/TypeOfAdmin");
const Roles = lazyLoad("Administrator/Roles");
const Permissions = lazyLoad("Administrator/Permissions");
const Institutes = lazyLoad("Institutes");
const Users = lazyLoad("Users");
const Trainings = lazyLoad("Trainings");
const Schedules = lazyLoad("Schedules");
const Calendar = lazyLoad("Calendar");
const Projects = lazyLoad("Projects");
const Tools = lazyLoad("Tools");
const Reports = lazyLoad("Reports");
const Inventory = lazyLoad("Inventory");

const Registration = lazyLoad("Administrator/Registration");
const RegistrationList = lazyLoad("Administrator/Registration/RegistrationList");
const RegistrationCreateEdit = lazyLoad("Administrator/Registration/RegistrationCreateEdit");

const FeedbackForms = lazyLoad("Administrator/FeedbackForms");
const FeedbackFormList = lazyLoad("Administrator/FeedbackForms/FeedbackFormList");
const FeedbackFormBuilder = lazyLoad("Administrator/FeedbackForms/FeedbackFormBuilder");
const FeedbackQuestionViewer = lazyLoad("Administrator/FeedbackForms/FeedbackQuestionViewer");

const Resources = lazyLoad("Administrator/Resources");
const ResourceList = lazyLoad("Administrator/Resources/ResourceList");
const ResourceCreatedEdit = lazyLoad("Administrator/Resources/ResourceCreatedEdit");

const TrainingCalendarList = lazyLoad("Calendar/TrainingCalendarList");
// const TrainingCalendarCreateEdit = lazyLoad("Calendar/TrainingCalendarCreateEdit");
const TrainingCalendarMapView = lazyLoad("Calendar/TrainingCalendarMapView");
const LatestLocationMapView = lazyLoad("Calendar/LatestLocationMapView");

const FeedbackResponse = lazyLoad("FeedbackResponse");
const FeedbackResponseList = lazyLoad("FeedbackResponse/FeedbackResponseList");
const FeedbackResponseViewer = lazyLoad("FeedbackResponse/FeedbackResponseViewer");


export const adminMainRoutes = [
  {
    path: "Dashboard",
    label: "Home",
    element: <Dashboard />,
    icon: createIcon("home"),
    module: ["admin"],
  },
  { path: "Profile", element: <Profile /> },
  {
    path: "Administrator",
    element: <Administrator />,
    icon: createIcon("administrator"),    
    module: ["admin"],
    children: [
      { path: "", element: <TypeOfAdmin /> },
      { path: "Roles", element: <Roles /> },
      { path: "Permissions", element: <Permissions /> },
      {
        path: "Resources",
        element: <Resources />,
        children: [
          { path: "", element: <ResourceList /> },
          { path: "Create", element: <ResourceCreatedEdit /> },
          { path: "ViewEdit", element: <ResourceCreatedEdit /> },
        ],
      },
      {
        path: "FeedbackForms",
        element: <FeedbackForms />,
        children: [
          { path: "", element: <FeedbackFormList /> },
          { path: "Create", element: <FeedbackFormBuilder /> },
          { path: "Edit", element: <FeedbackFormBuilder /> },
          { path: "View", element: <FeedbackQuestionViewer /> },
        ],
      },
      {
        path: "Registration",
        element: <Registration />,
        children: [
          { path: "", element: <RegistrationList /> },
          { path: "Create", element: <RegistrationCreateEdit /> },
          { path: "Edit", element: <RegistrationCreateEdit /> },
          { path: "View", element: <RegistrationCreateEdit /> },
        ],
      },
    ],
  },
  {
    path: "Users",
    element: <Users />,
    icon: createIcon("user"),
    children: userRoutes,
    module: ["admin"],
  },
  {
    path: "Projects",
    element: <Projects />,
    icon: createIcon("project"),
    children: projectRoutes,
    module: ["admin"],
  },
  {
    path: "Institutes",
    element: <Institutes />,
    icon: createIcon("institute"),
    children: instituteRoutes,
    module: ["admin"],
  },
  {
    path: "Trainings",
    element: <Trainings />,
    icon: createIcon("training"),    
    children: trainingRoutes,
    module: ["admin"],
  },
  {
    path: "Schedules",
    element: <Schedules />,
    icon: createIcon("training"),    
    children: scheduleRoutes,
    module: ["admin"],
  },
  {
    path: "Calendar",
    element: <Calendar />,
    icon: createIcon("calender"),    
    children: [
      { path: "", element: <TrainingCalendarList /> },
      { path: "MapView", element: <TrainingCalendarMapView /> },
      { path: "LatestLocationMapView", element: <LatestLocationMapView /> },
    ],
    module: ["admin"],
  },
  {
    path: "FeedbackResponse",
    label: "Feedback",
    element: <FeedbackResponse />,
    icon: createIcon("feedback"),    
    children: [
      { path: "", element: <FeedbackResponseList /> },
      { path: "View", element: <FeedbackResponseViewer /> },
    ],
    module: ["admin"],
  },
  {
    path: "Reports",
    element: <Reports />,
    icon: createIcon("report"),    
    children: reportRoutes,
    module: ["admin"],
  },
  {
    path: "Inventory",
    element: <Inventory />,
    icon: createIcon("inventory"),    
    children: inventoryRoutes,
    module: ["admin"],
  },
  {
    path: "Tools",
    element: <Tools />,
    icon: createIcon("repository"),    
    children: toolsRoutes,
    module: ["admin"],
  },
];
